export default {
  "Loop as a GIF": "Repetir como um GIF",
  "without sound": "sem som",
  "Final output duration": "Duração final do vídeo exportado",
};
